import type { FC } from 'react';

import type { DividerProps } from '@mui/material';
import { Divider, dividerClasses } from '@mui/material';

/** @draft */
export interface DividerCompProps extends DividerProps {
  title: string;
}

/** @draft */
export const DividerComp: FC<DividerCompProps> = ({ title, sx, ...props }) => {
  return (
    <Divider
      textAlign='left'
      sx={{
        color: (theme) => theme.palette.grey[600],
        lineHeight: '16px',
        fontSize: '10px',
        pt: 2,
        pb: 1,

        [`&.${dividerClasses.wrapper}`]: {
          paddingLeft: '4px',
          paddingRight: '4px'
        },

        [`&.${dividerClasses.root}::before`]: {
          width: '14px'
        },

        ...sx
      }}
      light
      {...props}
    >
      {title}
    </Divider>
  );
};
